import { Component, OnInit, Inject, Optional } from '@angular/core';
import { fieldWorkerLinkFormConfig } from '../field-worker-link.component';
import { FieldWorkerLink } from 'src/shared/api';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'rpshared-field-worker-link-dialog',
	templateUrl: './field-worker-link-dialog.component.html',
	styleUrls: ['./field-worker-link-dialog.component.scss'],
})
export class FieldWorkerLinkDialogComponent extends SelfDestruct
	implements OnInit {
	// CVA components can only be listened to through a form control
	control = new FormControl('') as FormControl;

	group = this.fb.group(fieldWorkerLinkFormConfig) as FormGroup;
	fieldWorkerLinkChoices: FieldWorkerLink[] = [];

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		readonly data: {
			fieldWorkerLink: FieldWorkerLink;
		},
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.setValue(v));

		if (this.data.fieldWorkerLink) {
			this.control.setValue(this.data.fieldWorkerLink);
		}
	}
}
